import React, { useState } from 'react';

const PlanetList = ({ planets, activePlanetId, onSelectPlanet, onAddPlanet }) => {
  return (
    <div className="planet-list bg-gray-700 border-r border-gray-600 flex flex-col h-full">
      <div className="flex-grow overflow-y-auto">
        {/* Empire View Option */}
        <div 
          onClick={() => onSelectPlanet('empire')}
          className={`p-2 cursor-pointer transition-colors duration-200 flex flex-col items-center ${
            activePlanetId === 'empire' ? 'bg-gray-600' : 'hover:bg-gray-600'
          }`}
        >
          {/* Empire icon */}
          <div className="w-12 h-12 rounded-full bg-purple-600 flex items-center justify-center mb-1">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h.5A2.5 2.5 0 0020 5.5v-.565M12 18.5V19" />
            </svg>
          </div>
          
          <div className="text-center">
            <div className="text-sm font-medium text-white truncate max-w-[80px]">
              Empire
            </div>
            <div className="text-xs text-gray-300">
              All Planets
            </div>
          </div>
        </div>
        
        {/* Divider */}
        <div className="border-t border-gray-600 my-2"></div>
        
        {/* Individual Planets */}
        {Object.keys(planets).map((planetId) => {
          const planet = planets[planetId];
          const isActive = planetId === activePlanetId;
          
          return (
            <PlanetListItem 
              key={planetId}
              planetId={planetId}
              planet={planet}
              isActive={isActive}
              onSelectPlanet={onSelectPlanet}
            />
          );
        })}
      </div>
      
      <button
        onClick={onAddPlanet}
        className="w-full py-2 bg-green-600 hover:bg-green-700 text-white font-medium"
      >
        +
      </button>
    </div>
  );
};

// Individual planet list item component with image error handling
const PlanetListItem = ({ planetId, planet, isActive, onSelectPlanet }) => {
  const [imageError, setImageError] = useState(false);
  
  return (
    <div 
      onClick={() => onSelectPlanet(planetId)}
      className={`p-2 cursor-pointer transition-colors duration-200 flex flex-col items-center ${
        isActive ? 'bg-gray-600' : 'hover:bg-gray-600'
      }`}
    >
      {/* Planet image */}
      {planet.imageName && !imageError ? (
        <img 
          src={`https://pr0game.com//styles/theme/nova/planeten/${planet.imageName}`}
          alt={planet.name}
          className="w-12 h-12 rounded-full object-cover mb-1"
          onError={() => setImageError(true)}
        />
      ) : (
        <div className="w-12 h-12 rounded-full bg-blue-500 flex items-center justify-center mb-1">
          {planetId}
        </div>
      )}
      
      <div className="text-center">
        <div className="text-sm font-medium text-white truncate max-w-[80px]">
          {planet.name}
        </div>
        <div className="text-xs text-gray-300">
          {planet.coordinates && typeof planet.coordinates === 'object'
            ? `[${planet.coordinates.galaxy}:${planet.coordinates.system}:${planet.coordinates.position}]`
            : planet.coordinates || `[${planetId}:1:1]`}
        </div>
      </div>
    </div>
  );
};

export default PlanetList;
